/* Senswell cart — voucher → native discount-input bridge.
   The voucher widget (snippets/cart-vouchers.liquid) lives in the custom cart
   summary. Clicking "Pakai" copies the code, fills Horizon's native discount
   field (#cart-discount), opens the discount accordion, and submits it so the
   native Horizon discount handler applies it. Event delegation on document so it
   survives Section Rendering API morphs. */
(function () {
  function flash(btn) {
    var txt = btn.querySelector('[data-voucher-btn-text]');
    if (!txt) return;
    var original = txt.textContent;
    txt.textContent = 'Tersalin';
    btn.classList.add('is-copied');
    setTimeout(function () {
      txt.textContent = original;
      btn.classList.remove('is-copied');
    }, 1600);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-voucher-copy]');
    if (!btn) return;

    var code = btn.getAttribute('data-code') || '';
    if (!code) return;

    // 1) Copy to clipboard (best-effort)
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).catch(function () {});
    }

    // 2) Fill the native Horizon discount input
    var input = document.getElementById('cart-discount');
    if (input) {
      // Open the surrounding <details> accordion if collapsed
      var details = input.closest('details');
      if (details && !details.open) details.open = true;

      input.value = code;
      input.focus();

      // 3) Submit the native discount form so Horizon applies the code
      var form = input.closest('form');
      if (form) {
        try {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        } catch (err) {
          /* If submit binding isn't ready, the code is filled and the user can
             click Apply manually. */
        }
      }
    }

    flash(btn);
  });
})();
